import styled from 'styled-components'

export const ContainerInfoSite = styled.div`
  padding: 35px 20px;
  .item {
    span,
    a {
      color: ${({ darkTheme }) => darkTheme && '#fff !important'};
    }
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0px;
    }
    .icon {
      width: 24px;
      img {
        max-width: 100%;
      }
    }
    p {
      flex: 1;
      margin-left: 20px;
      font-size: 14px;
      line-height: 141.52%;
      color: ${({ darkTheme }) => (darkTheme ? '#fff' : '#646981')};
      strong {
        font-size: 14px;
        color: ${({ darkTheme }) => (darkTheme ? '#fff' : '#646981')};
      }
    }
  }
  a.link-tel {
    font-size: 14px;
    text-decoration: none;
    color: #646981;
  }
`
